import { Project } from '..';

export interface GetProjectsResponse {
  count: number;
  projects: Project[];
}
